
  export default {
    mounted() {
      this.resizeObserver = new ResizeObserver(() => this.revealCurrent())
      this.resizeObserver.observe(this.el)
      this.revealCurrent()
    },
    updated() { this.revealCurrent() },
    destroyed() { this.resizeObserver.disconnect() },
    revealCurrent() {
      if (this.el.dataset.orientation !== "horizontal" || !this.el.clientWidth) return
      const list = this.el.querySelector("ul")
      const current = this.el.querySelector('[aria-current="page"]')
      if (!current) return
      const bounds = list.getBoundingClientRect()
      const tab = current.getBoundingClientRect()
      if (tab.left < bounds.left) list.scrollLeft += tab.left - bounds.left
      else if (tab.right > bounds.right) list.scrollLeft += tab.right - bounds.right
    },
  }
